module.exports = {"content":{},"productInfo":{"code":"{B1D698F8-C5EA-441E-BD51-32C2A769890F}","name":"フランス語　初中級","serialHead":"BCETJ","courseResourceIDs":[{"levelNo":1,"resourceID":"fa5cc47f4741783002b4903c910ebe6c4d3f1d97"},{"levelNo":2,"resourceID":"baa9dcafa0f1f268276ea38347de88ac51d8c58a"},{"levelNo":3,"resourceID":"4a827b0ebe6680f379f2b130168659a750e03cec"},{"levelNo":4,"resourceID":"1fcc2581da655dd3f46f32ab2d63d6d91010aa1b"},{"levelNo":5,"resourceID":"787a4352a1e76f79088b367a8578ebb344dac68c"}],"language":"fr-FR","challengeCount":33837},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1